import http from "./http_common";

class PrescriptionServices {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  getSharePrescription(id) {
    return http.get(`prescriptionDetails/list/filter?refNumber=${id}`);
  }
  getPrescriptionFromBEPDF(id) {
    return http.get(`prescriptionDetails/listPdf?refNumber=${id}`);
  }
}

export default new PrescriptionServices();
